import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const asthma: AnswerPathTreeNode = {
  path: 'asthma',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredAsthmaDetails }],
};
